<template>
  <modal type="text/x-template" id="modalProduct">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <div class="header">
                <h4 class="title">Edición de la Venta # {{sale.saleNumber}}</h4>
              </div>
              <div class="close-modal">
                <button class="button-close" @click="$emit('close')">X</button>
              </div>
            </div>

            <div class="modal-body">
              <p class="text">Seleccione el nuevo estado de la venta:</p>
              <b-form-select class="filter" v-model="sale.status" :options="getStatus()"></b-form-select>
            </div>

            <div class="modal-footer">
              <b-button type="submit" variant="primary" @click.prevent="editStatusOfSale()">Editar</b-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>

export default {
  props: {
    sale: {
      type: Object,
      default: () => {
        return {};
      }
    },
    status: {
      type: Array,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    getStatus() {
      var array = [];
      for (var i = 0; i < this.status.length; i++) {
        array.push(this.status[i].name);
      }
      return array;
    },
    editStatusOfSale() {
        this.$emit("editSale", this.sale);
    }
  }
};
</script>

<style scoped>
.header {
  width: 90%;
  margin-left: 10%;
  padding: 10px;
}

.filter {
  width: 270px;
}

.button {
  text-align: right;
}

.text {
  width: 310px;
  margin-top: 8px;
}

.produts-title {
  text-align: center;
  font-weight: bold;
}

.listProducts {
  margin-top: 10px;
  padding: 15px;
}

.product-code {
  padding-left: 50px;
  width: 200px;
}

.price {
  font-size: 25px;
  font-weight: 800;
  color: green;
  line-height: 1;
  padding-right: 5px;
  font-style: bold;
}

.paymentType {
  color: #000071;
  font-weight: 800;
  font-style: bold;
}

.items {
  padding: 20px;
  text-align: center;
}

.container {
  padding: 5px;
}

.item-container {
  padding: 10px;
  /* margin-bottom: 15px; */
}

.status {
  text-align: start;
}

.product-details {
  padding: 10px;
}

.product-name {
  width: 480px;
}

.product-total {
  margin-top: 10px;
  padding: 15px;
}

.customer-info {
  align-self: center;
  margin-top: 1px;
  margin-left: 20px;
}

.image {
  align-self: center;
  display: -webkit-inline-box;
}

.title {
  font-weight: 800;
}
.close-modal {
  width: 10%;
  text-align: end;
}
.button-close {
  background: red;
  border-radius: 20px;
  padding: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  min-width: fit-content;
  overflow-y: auto;
  border-radius: 10px !important;
}

.modal-header {
  margin-top: 0;
  color: #212529;
  text-align: center;
  justify-content: center;
  align-self: center;
}

.modal-body {
  margin: 5px 0;
  display: -webkit-inline-box;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/ModalEditTracking.vue